interface TypedCRUDError {
  field: string;
  code: number;
  message: string;
  value?: string;
}

export function getTypedCRUDErrors(error: any) {
  if (!error || !error.response || !error.response.data) {
    return [];
  }

  if (error.response?.data?.fields) {
    return error.response.data.fields as TypedCRUDError[];
  }
}
